import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import UploadPic from "./auto-tagging-service/auto-tagging-service-steps/AutoTaggingServiceUploadPic";
import AutoTagging from "./auto-tagging-service/auto-tagging-service-steps/AutoTaggingServiceTagging";
import { useAutoTaggingServiceContext } from "../../contexts/AutoTaggingServiceContext";
import { FREE_TRIAL } from "../../utilities/defaults/free-trial/plans";
import AutoTaggingServiceStepIndicator from "./auto-tagging-service/AutoTaggingServiceIndicator";
import AutoTaggingServiceResult from "./auto-tagging-service/auto-tagging-service-steps/AutoTaggingServiceResult";
import Loader from "../loading/Loader";

const AutoTaggingService: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { currentStep } = useAutoTaggingServiceContext();
  const [service, setService] = useState<typeof FREE_TRIAL[number] | null>(null);

  useEffect(() => {
    const foundService = FREE_TRIAL.find((service) => service.sdk_href === id);
    setService(foundService || null);
  }, [id]);

  if (!service) {
    return (
      <div className="flex justify-center w-full p-4 md:p-6">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col overflow-hidden border divide-y w-full divide-gorgonzola-blue-50 rounded-xl border-gorgonzola-blue-50">
      <Breadcrumb />

      <div className="flex flex-col items-center gap-4 p-4 xxl:gap-16 md:gap-6 lg:gap-8 xl:gap-12 md:p-6">
        <AutoTaggingServiceStepIndicator />

        <div className="flex justify-center w-full">
          {currentStep === 0 ? <UploadPic /> : null}
          {currentStep === 1 ? <AutoTagging /> : null}
          {currentStep === 2 ? <AutoTaggingServiceResult /> : null}
        </div>
      </div>
    </div>
  );
};

export default AutoTaggingService;
